export default __webpack_public_path__ + "static/media/Mark-3-HUD-02.8a2478d2.jpg";